import { detailFieldStyles } from '@v2/components';

export const styles = {
  wrapper: 'tw-flex tw-flex-col tw-gap-4',
  fieldContainer: detailFieldStyles.fieldContainer,
  emptyText: 'tw-text-sm tw-text-neutral-500 tw-p-2',
  cardGrid:
    'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-2 tw-p-2 tw-max-h-[50vh] tw-overflow-y-auto tw-overflow-x-hidden tw-content-start tw-auto-rows-min tw-items-stretch',
};
